import { Typography, Avatar } from "antd"
import { CheckOutlined } from "@ant-design/icons"
import UMCTable from "../common/UMCTable"
import FeatureListInfo from "./FeatureListInfo"
import { useWindowSize } from "../customHooks/useWindowSize";

const { Text } = Typography

const FeatureListTable = () => {

const [width, height] = useWindowSize()

const CheckWithText = (text) => (
  <div className="checkIcon-div">
    <Avatar
      icon={<CheckOutlined />}
      className="checkIcon-avatar"
    />
    {text && <Text className="checkIcon-text">{text}</Text>}
  </div>
)

const columns = [
  {
    title: "Features",
    dataIndex: "feature",
    key: "feature",
    render: text => <Text className="feature-text">{text}</Text>,
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    render: text => <Text className="description-text">{text}</Text>
  },
  {
    title: "Essential",
    dataIndex: "essential",
    key: "essential",
    align: "center",
    render: (value) => value === true ? CheckWithText() : CheckWithText(value),
  },
  // {
  //   title: "Enterprise",
  //   dataIndex: "enterprise",
  //   key: "enterprise",
  //   align: "center",
  //   render: (value) => value === true ? CheckWithText() : CheckWithText(value),
  // },
]


  return (
    <div className="feature-list-container">
      <UMCTable
        columns={columns}
        dataSource={FeatureListInfo}
        pagination={false}
        rowIndex={-1}
        height={height <= 585 ? "22em" : "60vh"}
      />
    </div>
  )
}

export default FeatureListTable
